<template>
  <div class="reports-wrap">
    <div class="mb-7 mt-5">
      <h2 class="headline">Reports</h2>
    </div>

    <div>
      <div v-if="loading" class="my-3">
        <v-progress-linear
          :indeterminate="loading"
          :class="{ 'no-opacity': !loading }"
          style="height: 2px;"
        ></v-progress-linear>
        <div class="text-center mt-4">Please wait...</div>
      </div>
      <div v-else>
        <v-layout class="wrap xs12">
          <v-flex class="xs12 sm6 md2" style="min-width: 270px;">
            <v-autocomplete
              :items="bannerTypes"
              label="Ads"
              item-text="banner_type"
              class="mb-3"
              style="max-width: 700px;"
              return-object
              v-model="banner"
              placeholder="Please Select"
            ></v-autocomplete>
          </v-flex>
          <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
            <v-menu
              ref="menu1"
              :close-on-content-click="false"
              label="From Date"
              v-model="menu1"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="date_from"
                  label="From Date"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  placeholder="Please Select"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_from"
                no-title
                :max="maxFromDate"
                @input="menu1 = false"
              >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex class="xs12 sm6 md2" style="min-width: 120px;">
            <v-menu
              ref="menu2"
              :close-on-content-click="false"
              label="To Date"
              v-model="menu2"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  v-model="date_to"
                  label="To Date"
                  persistent-hint
                  prepend-icon="mdi-calendar"
                  placeholder="Please Select"
                  readonly
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date_to"
                no-title
                :min="minToDate"
                :max="maxToDate"
                @input="menu2 = false"
              >
              </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <template v-if="banner">
          <template v-if="!loadingAllBanners">
            <template v-if="banners.length > 0">
              <div class="pointer action-link"></div>
              <v-btn
                v-if="banners.length > 1"
                text 
                small
                @click="showMore = !showMore"
                color="primary"
                class="mb-3"
              >{{ `${showMore ? 'Show Less' : 'Show More'}` }}
              </v-btn>
              <v-card v-for="item in filteredBanners" class="pa-5 mb-4" :key="item.id">
                <div class="subtitle">{{ `B-${item.id}`}} <span v-if="!no_data.includes(item.url)" @click="view(item.url)" class="body-2 pointer action-link">{{ item.url }}</span></div>
                <v-img v-if="!no_data.includes(item.image)"
                  :src="item.image"
                  :lazy-src="item.image"
                  :max-width="item.width"
                  :max-height="item.height"
                  class="my-2 pointer"
                  @click="$root.$emit('openImage', item.image)"
                ></v-img>
              </v-card>
            </template>
          </template>
          <v-card v-else class="pa-5 mb-4">
            <v-skeleton-loader
                  type="paragraph"
                  class="mx-auto"
            ></v-skeleton-loader>
          </v-card>
          <v-card class="pa-5 mb-4">
            <template v-if="loadingClickReport">
              <v-skeleton-loader
                type="heading"
                class="mx-auto"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                class="mt-4 mx-auto"
              ></v-skeleton-loader>
            </template>
            <template v-else>
              <h2 class="title">Click Reports</h2>
              <line-example :chart-data="clickReports"></line-example>
            </template>
          </v-card>
          <v-card class="pa-5 mb-4">
            <template v-if="loadingImpressionReport">
              <v-skeleton-loader
                type="heading"
                class="mx-auto"
              ></v-skeleton-loader>
              <v-skeleton-loader
                type="image"
                class="mt-4 mx-auto"
              ></v-skeleton-loader>
            </template>
            <template v-else>
              <h2 class="title">Impression Reports</h2>
              <line-example :chart-data="impressionReports"></line-example>
            </template>
          </v-card>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "@/common/api.service"
import LineExample from '@/common/LineChart.js'

export default {
  name: 'Reports',
  components: {
    LineExample
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      { text: "Name", value: "name", sort_column: 1 },
      { text: "Phone", value: "phone", sort_column: 2 },
      { text: "Web Site", value: "website", sort_column: 3 },
      { text: "Actions", value: "details", sortable: false, align: "left" }
    ],
    bannerTypes: [],
    banners: [],
    banner: null,
    clickReports: null,
    impressionReports: null,
    showMore: false,
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    loadingClickReport: false,
    loadingImpressionReport: false,
    loadingAllBanners: false,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    },
    date_from: moment().subtract(1, "y").format("YYYY[-]MM[-]DD"),
    date_to: moment().format("YYYY[-]MM[-]DD"),
    menu1: false,
    menu2: false,
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  mounted() {
    this.getBannerTypes()
  },
  methods: {
    getBannerTypes() {
      this.loading = true
      ApiService.get("/ban_types_list")
        .then(response => {
          this.bannerTypes = response.data.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error.message);
        });
    },
    getAllBanners(id) {
      this.loadingAllBanners = true
      ApiService.get("/ban_list", { ban_type_id: id })
        .then(response => {
          this.banners = response.data.data
          this.loadingAllBanners = false
        })
        .catch(error => {
          this.loadingAllBanners = false
          console.log(error.message);
        });
    },
    getClickReports(organizationId, bannerTypeId) {
      this.loadingClickReport = true
      let body = {
        organization_id: organizationId,
        ban_type_id: bannerTypeId,
        from: this.date_from,
        to: this.date_to
      }
      
      ApiService.get("/cl_report", body)
        .then(response => {
          if(!this.no_data.includes(response) && !this.no_data.includes(response.data) && !this.no_data.includes(response.data.data)) {
            let banners = response.data.data
            banners.map(i => {
              i.data1 = i.data.map(i => i.clicks)
              i.labels = i.data.map(i => i.date)
              i.label1 = `B-${i.id}`
              delete i.image
              delete i.data
            })
            this.clickReports = Object.assign({}, banners)
          }
          this.loadingClickReport = false
        })
        .catch(error => {
          this.loadingClickReport = false
          console.log(error.message);
        });
    },
    getImpressionReports(organizationId, bannerTypeId) {
      this.loadingImpressionReport = true
      let body = {
        organization_id: organizationId,
        ban_type_id: bannerTypeId,
        from: this.date_from,
        to: this.date_to
      }

      ApiService.get("/im_report", body)
        .then(response => {
          if(!this.no_data.includes(response) && !this.no_data.includes(response.data) && !this.no_data.includes(response.data.data)) {
            let banners = response.data.data
            banners.map(i => {
              i.data1 = i.data.map(i => i.impressions)
              i.labels = i.data.map(i => i.date)
              i.label1 = `B-${i.id}`
              delete i.image
              delete i.data
            })
            this.impressionReports = Object.assign({}, banners)
          }
          this.loadingImpressionReport = false
        })
        .catch(error => {
          this.loadingImpressionReport = false
          console.log(error.message);
        });
    },
    view (link) {
      window.open(link, '_blank')
    }
  },
  computed: {
    filteredBanners: function () {
      return this.banners.filter((i, index) => {
        if(this.banners.length > 0 && this.showMore) { return true }
        else return index === this.banners.length - 1
      })
    },
    minDate: function() {
      return moment().subtract(1, "y").format('YYYY[-]MM[-]DD')
    },
    maxFromDate: function() {
      if (this.date_to) {
        return moment(this.date_to)
          .subtract(1, "days")
          .format("YYYY[-]MM[-]DD");
      } else {
        return moment()
          .subtract(1, "days")
          .format("YYYY[-]MM[-]DD");
        return;
      }
    },
    minToDate: function() {
      if (this.date_from) {
        return moment(this.date_from)
          .add(1, "days")
          .format("YYYY[-]MM[-]DD");
      } else {
        return
      }
    },
    maxToDate: function() {
      return moment().format('YYYY[-]MM[-]DD')
    },
    updateIndicator() {
      return `${
        this.banner ?
          this.banner.id :
          this.banner
        }-${this.date_from}-${this.date_to}`
    }
  },
  watch: {
    'updateIndicator': function (val) {
      if(
        !this.no_data.includes(this.banner) &&
        !this.no_data.includes(this.banner.id) &&
        !this.no_data.includes(this.banner.organization_id)
      ) {
        this.getClickReports(this.banner.organization_id, this.banner.id)
        this.getImpressionReports(this.banner.organization_id, this.banner.id)
        this.getAllBanners(this.banner.id)
        this.showMore = false
      }
    }
  },
}
</script>
